import { TextKey } from '@mews-commander/enums';
import { LocalizedSectionTitleLarge } from '../../components/Typography';
import { FAQLayout } from '../../components/Layouts/FAQLayout';
import { QuestionsList } from './QuestionsList';

export const FAQSection = () => (
    <FAQLayout>
        <LocalizedSectionTitleLarge textKey={TextKey.FrequentlyAskedQuestions} />
        <QuestionsList />
    </FAQLayout>
);
